/**
 * Network/Chain Logo Utilities
 * Maps network codes to their logo assets
 */

// Network code mappings - maps API network codes to logo filenames
const NETWORK_LOGO_MAP: Record<string, string> = {
  // Ethereum and EVM chains
  ERC20: 'ethereum',
  ETH: 'ethereum',
  ETHEREUM: 'ethereum',

  // Binance Smart Chain
  BEP20: 'bsc',
  BSC: 'bsc',
  BNB: 'bsc',

  // Polygon
  MATIC: 'polygon',
  POLYGON: 'polygon',
  POL: 'polygon',

  // Avalanche
  AVAX: 'avalanche',
  AVALANCHE: 'avalanche',

  // Solana
  SOL: 'solana',
  SOLANA: 'solana',

  // Layer 2s
  ARBITRUM: 'arbitrum',
  ARB: 'arbitrum',
  OPTIMISM: 'optimism',
  OP: 'optimism',
  BASE: 'base',

  // Other networks
  CELO: 'celo',
  TRC20: 'tron',
  TRON: 'tron',
  TRX: 'tron',
  XLM: 'stellar',
  STELLAR: 'stellar',
  XRP: 'ripple',
  RIPPLE: 'ripple',
  BTC: 'bitcoin',
  BITCOIN: 'bitcoin',
};

/**
 * Get network logo URL from static assets
 * @param networkCode - Network code (e.g., "ERC20", "BEP20", "SOL")
 * @returns Local asset path or null if not found
 */
export function getNetworkLogoUrl(networkCode: string): string | null {
  const code = networkCode.toUpperCase();
  const logoFile = NETWORK_LOGO_MAP[code];

  if (logoFile) {
    return `/assets/networks/${logoFile}.png`;
  }

  return null;
}

/**
 * Get fallback color for network (used when logo fails to load)
 */
export function getNetworkColor(networkCode: string): string {
  const colors: Record<string, string> = {
    ERC20: '#627EEA',
    ETH: '#627EEA',
    ETHEREUM: '#627EEA',
    BEP20: '#F3BA2F',
    BSC: '#F3BA2F',
    BNB: '#F3BA2F',
    MATIC: '#8247E5',
    POLYGON: '#8247E5',
    POL: '#8247E5',
    AVAX: '#E84142',
    AVALANCHE: '#E84142',
    SOL: '#14F195',
    SOLANA: '#14F195',
    ARBITRUM: '#28A0F0',
    ARB: '#28A0F0',
    OPTIMISM: '#FF0420',
    OP: '#FF0420',
    BASE: '#0052FF',
    CELO: '#35D07F',
    TRC20: '#FF0013',
    TRON: '#FF0013',
    TRX: '#FF0013',
    XLM: '#000000',
    STELLAR: '#000000',
    XRP: '#00AAE4',
    RIPPLE: '#00AAE4',
    BTC: '#F7931A',
    BITCOIN: '#F7931A',
  };

  return colors[networkCode.toUpperCase()] || '#64748B';
}
